(() => {
  if (window.butiEcosystemReady) return;
  window.butiEcosystemReady = true;
  // Instagram reports its natural embed height. Match only our own frames
  // and the verified origin; never trust unrelated window messages.
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://www.instagram.com') return;
    const frame = [...document.querySelectorAll('.be-social__post iframe')]
      .find(item => item.contentWindow === event.source);
    if (!frame) return;
    let message;
    try { message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; }
    catch { return; }
    if (message?.type !== 'MEASURE') return;
    const height = Number(message.details?.height);
    if (Number.isFinite(height) && height >= 250 && height <= 1600) {
      frame.style.height = `${Math.ceil(height) + 2}px`;
    }
  });
  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-be-play]');
    if (play) {
      const screen = play.closest('.be-film__screen');
      const frame = document.createElement('iframe');
      const source = new URL(play.dataset.bePlay);
      source.searchParams.set('autoplay', '1');
      source.searchParams.set('playsinline', '1');
      frame.src = source.href;
      frame.title = play.dataset.beTitle || 'BUTI video';
      frame.allow = 'autoplay; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      screen.replaceChildren(frame);
      frame.focus();
    }
    const reset = event.target.closest('[data-be-reset]');
    if (reset) {
      const scope = reset.closest('[data-be-compare]');
      scope.querySelectorAll('input[type=checkbox]').forEach(input => input.checked = false);
      scope.querySelectorAll('[data-be-format]').forEach(item => item.hidden = false);
      scope.querySelector('[data-be-status]').textContent = `Showing all ${scope.querySelectorAll('[data-be-format]').length} formats`;
    }
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-be-choice]')) return;
    const scope = event.target.closest('[data-be-compare]');
    const chosen = [...scope.querySelectorAll('[data-be-choice]:checked')].map(input => input.value);
    scope.querySelectorAll('[data-be-format]').forEach(item => item.hidden = chosen.length > 0 && !chosen.includes(item.dataset.beFormat));
    scope.querySelector('[data-be-status]').textContent = chosen.length ? `Showing ${chosen.length} selected format${chosen.length === 1 ? '' : 's'}` : `Showing all ${scope.querySelectorAll('[data-be-format]').length} formats`;
  });
})();
